export default __webpack_public_path__ + "static/media/share.1d6c6252.svg";